import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';

export const storyblokHeaderResolver = (route: ActivatedRouteSnapshot) => {
  return inject(PICFLOW_STORYBLOK)
    .getStory('headers/website-header', route)
    .pipe(map(resp => (resp && resp.story) || (false as const)));
};
